
import { getDocs, collection, query , where} from 'firebase/firestore';
import { db } from '../../../config/firebase-config';


const TABLE_NAME = "MainFields";
const TABLE_FIELDS = {
    Form: "Form",
    Type: "Type",
    Fields: "Fields", //array
    Sections: "Sections", //array
}

const MainFieldsCollectionRef = collection(db, TABLE_NAME);
const MainFieldsQueryAsc = query(MainFieldsCollectionRef);

//get Sections
export const getMainFieldsTable = async () => {
    try {
        const data = await getDocs(MainFieldsQueryAsc);
        const filteredData = data.docs.map((doc) => ({
            ...doc.data(),
            Id: doc.id
        }))
        return filteredData;
    } catch (error) {
        throw error;
    }
}

export const getMainFieldsByFormType = async (form, type) => {
    try {
        const query1 = await getDocs(
            query(MainFieldsCollectionRef, 
                where(TABLE_FIELDS.Form, "==", form),
                where(TABLE_FIELDS.Type, "==", type))//uncomment if needs to be specific in form
                // where(TABLE_FIELDS.Type, "==", type)) //uncomment if the fields can share
        );
        const data = query1.docs.map( doc => doc.data() );
        //always get the first query
        return data.length > 0 ? data[0] : [];
    } catch (error) {
        throw error;
    }
};
